import { z } from 'zod';
import { Box } from '@/shared/ui';

import ColorPaletteSelector from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector';
import { ColorPalette } from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/const';
import { ItemSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ItemSelection';
import { TabName } from '@/features/dashboard/components/AppForm/AppForm/components/TabName';
import type { ChartFormValues } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { DrawerStep } from '@/features/dashboard/components/Drawer/types';
import type { FWDChartWidgetV2 } from '@/features/dashboard/types';
import { AppType } from '@/features/dashboard/types';

import { FWD_CHART_MAX_ITEMS } from '@/features/dashboard/constants/const';
import type { FormAppDefinition } from '../types';
import {
  buildChart,
  ColorPaletteSchema,
  graphToFormValues,
  NameSchema,
  SymbolsStateSchema
} from './_helpers';

export const fwdChartDefinition: FormAppDefinition<ChartFormValues, FWDChartWidgetV2> = {
  type: AppType.FWD,
  drawerStep: DrawerStep.SelectFWDChart,
  dashboardControls: { edit: true },
  widgetControls: { export: true },
  maxItems: FWD_CHART_MAX_ITEMS,
  initialValues: {
    name: 'Forward Curves chart',
    type: AppType.FWD,
    symbols: { active: [], backlog: [] },
    colorPalette: ColorPalette.Vibrant
  },
  schema: z.object({
    id: z.string().optional(),
    type: z.literal(AppType.FWD),
    name: NameSchema,
    symbols: SymbolsStateSchema,
    colorPalette: ColorPaletteSchema,
    from: z.string().optional()
  }),
  heading: {
    title: 'Configure forward curves chart',
    subtitle: 'Set up your chart preferences and data'
  },
  Form: () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <TabName />
      <ItemSelection />
      <ColorPaletteSelector />
    </Box>
  ),
  toWidget: values => buildChart(values),
  canEditWidget: (w): w is FWDChartWidgetV2 =>
    w.type === 'graph' && w.metadata?.graphType === 'forwardSimple',
  fromWidget: w => graphToFormValues(w)
};
